const base = {
  name: 'Liz Gordon Music',
  url: 'http://lizgordonmusic.com.s3-website-us-east-1.amazonaws.com'
};

const config = {
  /* meta tags */
  siteTitle: `${base.name} `,
  siteTitlePostfix: ` - ${base.name}`,
  siteDescription: `${
    base.name
  } website, Blog, music,christian,faith,hyms,confessions`,
  logo: "/logo.jpg",
  siteImage: 'preview.png',
  siteLanguage: 'en',

  /* site header */
  headerTitle: `${base.name}`,
  headerSubTitle: 'Christian Musics',

  /* url */
  siteUrl: base.url
  // pathPrefix: '',
};

module.exports = config;
